import {
  fallback,
  KlevuFetch,
  KlevuKMCSettings,
  KlevuLastSearches,
  KlevuLastClickedProducts,
  KlevuTypeOfRecord,
  KlevuTypeOfRequest,
  personalisation,
  raw,
  search,
  suggestions,
  trendingProducts,
} from "@klevu/core";
import { getKlevuId } from "../klevu";

export default (query) => ({
  categories: [],
  clickManager: () => {},
  //   lastSearches: KlevuLastSearches.get(),
  loading: false,
  posts: [],
  products: [],
  query: query,
  settings: {},
  show: false,
  suggestions: [],
  trendingProducts: [],

  get hasProducts() {
    return this.hasQuery && this.products.length > 0;
  },

  get hasCategoriesOrPosts() {
    return !!(this.categories.length + this.posts.length);
  },

  get hasCategories() {
    return !!this.categories.length;
  },

  get hasPosts() {
    return !!this.posts.length;
  },

  get hasQuery() {
    return !!(this.query || "").trim().length;
  },

  get popularSearches() {
    return this.settings.klevu_webstorePopularTerms;
  },

  init() {
    this.fetchKMCSettings();
    this.$watch("query", this.search.bind(this));
    this.search();
  },

  focus() {
    this.$refs.searchInput.focus();
  },

  blur() {
    this.$refs.searchInput.blur();
  },

  onFormSubmit(event) {
    const inputValue = this.$refs.searchInput.value.trim();
    if (!inputValue) {
      event.preventDefault();
    }
  },

  close() {
    this.show = false;
    Grebify.noScroll(!this.show);
    this.blur();
  },

  open() {
    this.show = true;
    // Need timeout to wait for search-drawer to finish css transition otherwise focus wont work
    setTimeout(() => this.focus(), 400);
  },

  stripHtml(string) {
    return string.replace(/(<([^>]+)>)/gi, "");
  },

  toggle() {
    var show = !this.show;
    Grebify.noScroll(!show);
    if (show) {
      this.open();
    } else {
      this.close();
    }
  },

  handleLastSearchesUpdate() {
    this.lastSearches = Array.from(KlevuLastSearches.get()).reverse();
  },

  reset() {
    this.query = "";
    this.focus();
    this.search();
  },

  async fetchKMCSettings() {
    const settings = await KlevuKMCSettings();
    this.settings = settings.root;
  },

  async fetchEmptySuggestions() {
    // this.handleLastSearchesUpdate();

    const res = await KlevuFetch(
      raw(
        {
          id: "trendingProducts",
          typeOfRequest: KlevuTypeOfRequest.Trending,
          settings: {
            limit: 4,
            typeOfRecords: [KlevuTypeOfRecord.Product],
          },
        },
        personalisation(),
        fallback(trendingProducts())
      )
    );

    this.trendingProducts = res.queriesById("trendingProducts")?.records ?? [];
  },

  async search() {
    const query = this.query;
    if (!query) return;

    this.loading = true;
    const result = await KlevuFetch(
      search(
        query,
        {
          limit: 4,
          typeOfRecords: [KlevuTypeOfRecord.Product],
        },
        personalisation()
      ),
      search(query, {
        id: "categories",
        limit: 3,
        typeOfRecords: [KlevuTypeOfRecord.Category],
        groupBy: "name",
      }),
      search(query, {
        id: "posts",
        limit: 3,
        typeOfRecords: [KlevuTypeOfRecord.Cms],
        groupBy: "name",
      }),
      suggestions(query, {
        limit: 5,
        hlStartElem: "<strong class='highlight'>",
        hlEndElem: "</strong>",
      })
    );

    this.loading = false;

    const searchResult = result.queriesById("search");

    //this.clickManager = searchResult.getSearchClickSendEvent();
    this.products = searchResult?.records ?? [];
    this.categories =
      result
        .queriesById("categories")
        ?.records.map((r) => ({ name: r.name, url: r.url })) ?? [];
    this.posts =
      result
        .queriesById("posts")
        ?.records.map((r) => ({ name: r.name, url: r.url })) ?? [];
    this.suggestions =
      result
        .suggestionsById("suggestions")
        ?.suggestions.map((i) => i.suggest) ?? [];
  },

  async handleProductClick(event) {
    try {
      const id = event.currentTarget.getAttribute("data-id");
      const groupId = event.currentTarget.getAttribute("data-groupId");
      const name = event.currentTarget.getAttribute("data-name");
      const url = event.currentTarget.getAttribute("data-url");

      var klevuId = getKlevuId();
      if (!klevuId) {
        throw new Error("No Klevu ID available");
      }

      /* console.log("id", id);
      console.log("groupId", groupId);
      console.log("name", name);
      console.log("url", url);
      console.log("klevuId", klevuId);
      console.log("klevu_keywords", this.query); */

      const raw = {
        klevu_apiKey: klevuId,
        klevu_keywords: this.query,
        klevu_type: "clicked",
        klevu_productId: id,
        klevu_productGroupId: groupId,
        klevu_productVariantId: id,
        klevu_productName: name,
        klevu_productUrl: url,
      };

      const baseUrl = "https://stats.ksearchnet.com/analytics/productTracking";

      // Function to build the query string
      const buildQueryString = (params) => {
        return Object.keys(params)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          )
          .join("&");
      };

      const fullUrl = `${baseUrl}?${buildQueryString(raw)}`;

      fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },

  handleSuggestionsClick(event) {
    const id = event.currentTarget.getAttribute("data-id");
    const product = this.trendingProducts.find((product) => product.id === id);
    if (product) {
      KlevuLastClickedProducts.click(id, product);
    }
  },
});
